module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('span', {
    staticClass: "th11"
  }, [_vm._v("Best Laid Trap")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("By Rob Rosen")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Roy has a crush on Steve, so when a work-related ski weekend is offered, Roy jumps at the chance to finally lay a trap for his hunky coworker. An abandoned cabin nearby is perfect for his scheme, and Roy stocks it with champagne, rubbers, and lube. But fate intervenes, and it’s not Steve, but Ranger Josh, who ends up trapped in the cabin with Roy during an avalanche. Roy’s plan might be ruined, but there’s still a chance for a very happy New Year indeed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0